import { makeStyles } from '@mui/styles';

export const useTimelineRowsStyles = makeStyles({
  rows: {
    '& > div:last-child > div:last-child': {
      display: 'none'
    }
  }
});
